export const logAndExtractError = error => {
  const errorMessage = (error.response && error.response.data && error.response.data.message) || error
  return errorMessage
}

export const extractStatusCode = error => (
  (error.response && error.response.status) || null
)
